module.exports = __webpack_public_path__ + "static/media/revo.479e923d.png";